import { mergeFragments, TableFragment, CellMarkdown, Sheet, Spreadsheet } from "./excel-model";

function titlePage(tableName) {
  const date = new Date();
  const dateStr = `${date.getDay()}.${date.getMonth()}.${date.getFullYear()}`;
  return new Sheet("Титульный лист", new TableFragment([2, 5], {
    data: [
      ["Отчёт о проведённом статистическом анализе", ""],
      ["", ""],
      ["По данным:", tableName || "<источник данных без названия>"],
      ["", ""],
      ["Дата отчёта:", dateStr],
    ],
    markdown: [
      { type: "cell", coord: [0, 0], style: { font: { bold: true, sz: 36 } } },
      { type: "cell", coord: [1, 4], format: { type: "date" } },
    ],
    columnWidth: [
      { wpx: 400 },
      { wpx: 400 },
    ],
    rowHeight:  [
      { hpx: 50 },
      { hpx: 20 },
      { hpx: 20 },
      { hpx: 20 },
      { hpx: 20 },
    ],
  }));
}

function tablePage(table) {
  return new Sheet("Данные",
    new TableFragment([table.headers.length, 1 + table.data.length], {
      data: [table.headers, ...table.data],
      markdown: [
        { type: "row", coord: 0, style: { font: { bold: true } } },
      ],
    }));
}

function jsonData(cell, domain) {
  return new Sheet("JSON",
    TableFragment.plainData([
      [JSON.stringify(cell)],
      [JSON.stringify(domain)],
    ]));
}

export default function makeReport(cell, domain) {
  const { table, properties, name } = cell;
  const spreadsheet = new Spreadsheet([
    titlePage(name),
    tablePage(table),
    jsonData(cell, domain),
  ]);
  spreadsheet.createExcel();
}
